import type { SVGProps } from "react";
export function Youtube(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        d="m14.3619 4.33196c.3047 1.188.3047 3.668.3047 3.668s0 2.48004-.3047 3.66804c-.1693.6566-.6646 1.1733-1.292 1.348-1.1393.3173-5.06998.3173-5.06998.3173s-3.92867 0-5.07-.3173c-.63-.1774-1.12467-.6934-1.292-1.348-.30467-1.188-.30467-3.66804-.30467-3.66804s0-2.48.30467-3.668c.16933-.65667.66467-1.17333 1.292-1.348 1.14133-.31733 5.07-.31733 5.07-.31733s3.93068 0 5.06998.31733c.63.17733 1.1247.69333 1.292 1.348zm-7.69532 6.00134 4.00002-2.33334-4.00002-2.33333z"
        fill="currentColor"
      />
    </svg>
  );
}
